import { BaseService, Service } from "/@/cool";

@Service("productPackage")
class ProductPackage extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["price"] = prefix + "price";
		this.permission["listByPid"] = prefix + "listByPid";
	}

	// 获取产品包列表
	list(params: any) {
		return this.request({
			url: "/list",
			method: "GET",
			params
		});
	}

	// 根据拍照订单ID获取可用套餐列表（聚合产品筛选+套餐查询）
	listByPid(params: any) {
		return this.request({
			url: "/listByPid",
			method: "GET",
			params
		});
	}

	// 获取产品包详情
	info(params: any) {
		return this.request({
			url: "/info",
			method: "GET",
			params
		});
	}

	// 获取产品包价格
	price(params: any) {
		return this.request({
			url: "/price",
			method: "GET",
			params
		});
	}
}

export default ProductPackage;
